import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
  pageTheme,
} from '@backstage/theme';

export const customTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
    },
  }),
  pageTheme: {
    ...pageTheme,
    'environment-template': genPageTheme({
      colors: ['#c28b00', '#916600'],
      shape: shapes.wave2,
    }),
    'project-template': genPageTheme({
      colors: ['#6A5ACD', '#191970'],
      shape: shapes.round,
    }),
    'delete-template': genPageTheme({
      colors: ['#d44b4bff', '#cb4747ff'],
      shape: shapes.round,
    }),
  },
});
